import { render } from "./SvgIcon.vue?vue&type=template&id=77d8e5eb&scoped=true&ts=true"
import script from "./SvgIcon.vue?vue&type=script&lang=ts"
export * from "./SvgIcon.vue?vue&type=script&lang=ts"

import "./SvgIcon.vue?vue&type=style&index=0&id=77d8e5eb&scoped=true&lang=css"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d8e5eb"]])

export default __exports__